import {makeStyles} from "@material-ui/core";
import React from "react";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  root: props => ({
    "& > p": {
      marginBottom: 0
    },
    "& ul": {
      marginTop: 0,
      marginBottom: 0
    },
    "& ol": {
      marginTop: 0,
      marginBottom: 0
    }
  })
}));

export const View = ({
  text,
  html,
  size,
  emptyLabel,
  style,
  className,
  textClassName
}) => {
  const getConfig = () => {
    switch (size) {
      case "xs":
        return {
          textClassName: "c-text-s1 mb-0"
        };
      case "sm":
        return {
          textClassName: "c-text-s1d5 mb-0"
        };
      case "md":
        return {
          textClassName: "c-text-s2 mb-0"
        };
      default:
    }
    return {
      textClassName: "c-text-s2 mb-0"
    };
  };

  const renderText = (config, classes) => {
    let temp = text.split("\n");

    return (
      <div className={clsx("c-html", classes.root, className)} style={style}>
        {temp.map((item, i) => {
          return (
            <p
              key={i}
              className={clsx("c-wrap", config.textClassName, textClassName)}
            >
              {item}
            </p>
          );
        })}
      </div>
    );
  };

  const renderHtml = (config, classes) => {
    return (
      <div
        className={clsx(
          "c-html",
          classes.root,
          config.textClassName,
          textClassName,
          className
        )}
        style={style}
        dangerouslySetInnerHTML={{__html: html}}
      />
    );
  };

  let config = getConfig();
  let classes = useStyles();
  return text ? renderText(config, classes) : renderHtml(config, classes);
};

View.defaultProps = {
  size: "sm",
  textClassName: "",
  className: ""
};
